import { useState } from 'react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import Section from '../components/Section.jsx';

const EMPTY = { fname: '', lname: '', email: '', subject: '', message: '' };

const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');

const ContactUs = () => {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState('');

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    // fetch only rejects on network failure, so a 404/500 has to be checked
    // explicitly or every response looks like a success.
    fetch('/contact-us', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'form 1', ...form }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        setStatus('success');
        setForm(EMPTY);
      })
      .catch(() => setStatus('error'));
  };

  return (
    <div id="page">
      <Header
        plain
        title="Contact Us"
        heading="Get in touch."
        kicker="Contact"
        tagline="Planning a visit, or have something to add to these pages? Write to us."
      />

      <Section narrow id="movehere">
        {/* Netlify Forms detects this form in the prerendered HTML at deploy
            time; React drops a bare `netlify` attribute, hence data-netlify. */}
        <form
          className="form reveal"
          method="post"
          name="form 1"
          data-netlify="true"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value="form 1" />

          <div className="field-row">
            <div className="field">
              <label htmlFor="fname">First name</label>
              <input
                id="fname"
                name="fname"
                type="text"
                required
                placeholder="Your first name"
                value={form.fname}
                onChange={handleChange}
              />
            </div>
            <div className="field">
              <label htmlFor="lname">Last name</label>
              <input
                id="lname"
                name="lname"
                type="text"
                required
                placeholder="Your last name"
                value={form.lname}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label htmlFor="subject">Subject</label>
            <input
              id="subject"
              name="subject"
              type="text"
              placeholder="What is this about?"
              value={form.subject}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="8"
              placeholder="Write us something"
              value={form.message}
              onChange={handleChange}
            />
          </div>

          <button className="btn" type="submit" disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending…' : 'Send message'}
          </button>

          <p aria-live="polite">
            {status === 'success' && (
              <span className="form-status form-status--success">
                Thanks — your message has been sent.
              </span>
            )}
            {status === 'error' && (
              <span className="form-status form-status--error">
                Sorry, something went wrong. Please try again.
              </span>
            )}
          </p>
        </form>
      </Section>

      <Footer />
    </div>
  );
};

export default ContactUs;
